export const getDateRangeBetweenDays = (
  today: Date,
  daysStart: number,
  daysEnd: number,
): { from: string; to: string } => {
  const fromDate = new Date(today);
  fromDate.setUTCDate(today.getDate() + daysStart);
  const toDate = new Date(today);
  toDate.setUTCDate(today.getDate() + daysEnd);
  return { from: fromDate.toUTCString(), to: toDate.toUTCString() };
};
